<template>
  <div class="clearfix">
    <div
      id="idleTimeCheckModal"
      ref="idleTimeCheckModal"
      class="reveal"
      data-reveal
    >
      <div class="tender-confirm clearfix">
        <p class="confirm-header">
          {{ $t('warn.session.renew') }}
        </p>
        <div class="row align-center">
          <button
            id="confirm_ok"
            type="button"
            class="btn btn--orange"
            @click="extendSession()"
          >{{ $t('action.renew') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import lodash from 'lodash'

import EventBus from '@/utils/eventBus'
import i18n from '@/utils/i18n'
import notification from '@/utils/notification'
import { noExtendSessionPaths } from '@/utils/regex'
import { checkStatus } from '@/api/users/request'
import { getTimeoutSettings } from '@/api/settings/request'

export default {
  data () {
    return {
      enableCheck: true,
      uiIdleTimeout: 28800000,
      idleReminderTimeout: 120000,
    }
  },

  async mounted () {
    EventBus.$on('apps_start_check_expire', () => {
      this.enableCheck = true
    })
    EventBus.$on('apps_stop_check_expire', () => {
      this.enableCheck = false
    })
    const timeout = await getTimeoutSettings()
    this.uiIdleTimeout = timeout.uiIdleTimeout || this.uiIdleTimeout
    this.idleReminderTimeout = timeout.idleReminderTimeout || this.idleReminderTimeout

    this.idleCheck(this.openModal)
  },
  destroyed () {
    EventBus.$off('apps_start_check_expire')
    EventBus.$off('apps_stop_check_expire')
    if (this.idleTimeCheckModal) {
      this.idleTimeCheckModal.destroy()
    }
    $('#idleTimeCheckModal').remove()
  },
  methods: {
    ...mapActions('user', ['logout']),
    idleCheck (action) {
      let resetTimer = () => {
        clearTimeout(this.idleCheckTimer)
        this.idleCheckTimer = setTimeout(() => {
          if (this.enableCheck) {
            action()
          }
        }, this.uiIdleTimeout)
      }

      resetTimer = lodash.throttle(resetTimer, 1000)
      window.onload = resetTimer
      window.onmousemove = resetTimer
      window.onmousedown = resetTimer
      window.ontouchstart = resetTimer
      window.onclick = resetTimer
      window.onkeypress = resetTimer
      window.addEventListener('scroll', resetTimer, true)
    },
    async init () {
      if (!this.idleTimeCheckModal) {
        this.idleTimeCheckModal = await new Foundation.Reveal($('#idleTimeCheckModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
    },
    async openModal () {
      if (Object.values(noExtendSessionPaths).some(path => path.test(location.hash.replace('#', '')))) {
        return
      }
      await this.init()
      $('#idleTimeCheckModal').parent().css('z-index', '1011')
      this.idleTimeCheckModal.open()
      clearTimeout(this.logoutJob)
      this.logoutJob = setTimeout(() => {
        EventBus.emit('modules_confirm_continue_close')
        EventBus.emit('modules_no_perm_modal_close')
        this.closeModal()
        $('body>div.reveal-overlay:visible').css('display', 'none')
        this.logout()
        notification.warn(i18n.t('hint.sessionExpireMessage'))
      }, this.idleReminderTimeout)
    },
    async closeModal () {
      if (this.idleTimeCheckModal) {
        this.idleTimeCheckModal.close()
      }
      clearTimeout(this.logoutJob)
    },
    async extendSession () {
      clearTimeout(this.logoutJob)
      try {
        await checkStatus(true)
      } catch (err) {
        // do nothing
      } finally {
        this.idleTimeCheckModal.close()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
@import '~styles/popup';
</style>

<style lang="scss">
#idleTimeCheckModal {
  z-index: 1020;
  width: 500px;
  font-weight: bold;
  .confirm-header {
    font-size: 14px;
  }
}
</style>
